import React, {Component} from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  CustomInput
} from "reactstrap";

export default function DSModal({
  meta: {
    heading,
    footer: { save: saveText, cancel: cancelText }
  },
  states: {
    isOpen: { open, setOpen },
    formData: { data: formData, changeData },
    competencyData,
    disabled
  },
  trigger
}) {
  return (
    <Modal isOpen={!!open} centered={true}>
      <ModalHeader
        toggle={() => setOpen(false)}
        className="bg-black text-white text-uppercase custom-header"
      >
        {heading}
      </ModalHeader>
      <ModalBody>
        {formData.map(form_input => {
          return (
            <FormInput
              {...form_input}
              changeFormData={changeData}
              formData={formData}
            />
          );
        })}
        {!competencyData.hide && (
          <FitmentCompentencyTable {...competencyData} />
        )}
      </ModalBody>
      <ModalFooter
        style={{
          justifyContent: "center"
        }}
      >
        {cancelText && (
          <Button
            style={{
              borderRadius: 0,
              margin: "0px 10px"
            }}
            onClick={() => setOpen(false)}
          >
            {cancelText}
          </Button>
        )}
        {saveText && (
          <Button
            style={{
              borderRadius: 0,
              margin: "0px 10px",
              backgroundColor: "#007bff",
              borderColor: "#007bff"
            }}
            onClick={trigger}
            disabled={disabled}
          >
            {saveText}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
}

const FormInput = ({
  refer_key,
  input_type,
  input_label,
  input_value,
  input_placeholder,
  input_hidden,
  elementConfig,
  changeFormData,
  formData
}) => {
 
  const {
    options = [],
    option_value_key = "",
    option_label_key = ""
  } = elementConfig;

  const changeFormValue = ({ target }) => {
    const value = input_type === "checkbox" ? target.checked : target.value;
    const objectToUpdate = formData.find(item => {
      return item.refer_key === refer_key;
    });
    const inputRegex = new RegExp(objectToUpdate.input_regex);
    const updatedValue = {
      ...objectToUpdate,
      input_value: value,
      input_valid: inputRegex.test(value)
    };

    changeFormData({ value: updatedValue, refer_key, data: formData });
  };
  const renderInputChildren = key => {
    if (input_hidden) {
      return <div />;
    }
    switch (key) {
      case "select":
        return (
          <FormGroup>
            <Label>{input_label}</Label>
            <Input
              type={input_type}
              name={refer_key}
              id={refer_key}
              placeholder={input_placeholder}
              value={input_value}
              onChange={changeFormValue}
              hidden={input_hidden}
            >
              <option value={-1}>Choose an Option...</option>
              {options.map(option => {
                return (
                  <option value={option[option_value_key]}>
                    {option[option_label_key]}
                  </option>
                );
              })}
            </Input>
          </FormGroup>
        );
      case "checkbox":
        return options.map(checkbox => {
          return (
            <FormGroup>
              <Label>{input_label}</Label>
              <CustomInput
                type="checkbox"
                id={checkbox[option_label_key]}
                label={checkbox[option_label_key]}
                onChange={changeFormValue}
                checked={input_value}
                hidden={input_hidden}
                inline
              />
            </FormGroup>
          );
        });
      default:
        return (
          <FormGroup>
            <Label>{input_label}</Label>
            <Input
              type={input_type}
              name={refer_key}
              id={refer_key}
              placeholder={input_placeholder}
              value={input_value}
              hidden={input_hidden}
              onChange={changeFormValue}
            />
          </FormGroup>
        );
    }
  };

  return renderInputChildren(input_type);
};

class FitmentCompentencyTable extends Component {
  updateListContainer = () => {
    const {
      selectedOptions,
      selectOptions,
      currentSelectedOption,
      updateList
    } = this.props;
    const currentSelectOption = selectOptions.find(
      item => item.id === currentSelectedOption
    );
    if (currentSelectOption) {
      const updatedSelectedOptions = [...selectedOptions, currentSelectOption];
      updateList(updatedSelectedOptions);
    }
  };
  componentDidMount() {
    const {
      selectedOptions,
      updateList
    } = this.props;
    if(updateList) {
      const updatedSelectedOptions = [...selectedOptions];
      updateList(updatedSelectedOptions);
    }
  }
  removeSingleMetric = id => {
    const {
      selectedOptions,
      updateList
    } = this.props;
    const updatedSelectedOptions = selectedOptions.filter(
      item => item.id !== id
    );
    updateList(updatedSelectedOptions);
  };
  render() {
    const {
      selectedOptions,
      selectOptions,
      currentSelectedOption,
      changeSelectedOption,
      label_key,
      hideDropdown = false,
      noDelete = false
    } = this.props;
  
    return (
      <div>
        <table
          style={{
            margin: "0px",
            marginBottom: 20,
            width: "100%",
            boxShadow: "rgba(0, 0, 0, 0.2) 0px 1px 3px",
            borderCollapse: "collapse"
          }}
        >
          <thead style={{ backgroundColor: "black", color: "white" }}>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  padding: 5,
                  width: "85%"
                }}
              >
                Attribute
              </th>
              <th
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  padding: 5,
                  width: "15%"
                }}
              ></th>
            </tr>
          </thead>
          <tbody style={{ color: "#717171" }}>
            {!hideDropdown && (
              <tr>
                <td
                  style={{ fontSize: "12px", padding: 5 }}
                  className="styled-select slate"
                >
                  <select
                    style={{
                      fontSize: "12px"
                    }}
                    onChange={e => changeSelectedOption(+e.target.value)}
                  >
                    {currentSelectedOption ? (
                      <option value="0">Choose an option ... </option>
                    ) : (
                      <option value="0" selected>
                        Choose an option ...{" "}
                      </option>
                    )}
                    {selectOptions.map(val => (
                      <option value={val.id}>{val[label_key]}</option>
                    ))}
                  </select>
                </td>
                <td style={{ padding: 5 }}>
                  <Button
                    type="button"
                    onClick={() => this.updateListContainer()}
                    disabled={!currentSelectedOption}
                    style={{
                      minWidth: "40px",
                      margin: "0px 5px",
                      padding: "0px 10px",
                      lineHeight: "25px",
                      height: "25px",
                      fontSize: "0.8rem",
                      border: "none",
                      backgroundColor: "rgb(124, 141, 159)",
                      color: "white",
                      outline: "none",
                      cursor: "pointer"
                    }}
                  >
                    <span className="fas fa-plus"></span>
                  </Button>
                </td>
              </tr>
            )}
            {selectedOptions.map(val => (
              <tr>
                <td style={{ padding: 5 }}>{val[label_key]}</td>
                <td style={{ padding: 5 }}>
                  {!noDelete && (
                    <Button
                      type="button"
                      onClick={() => this.removeSingleMetric(val.id)}
                      style={{
                        minWidth: "40px",
                        margin: "0px 5px",
                        padding: "0px 10px",
                        lineHeight: "25px",
                        height: "25px",
                        fontSize: "0.8rem",
                        border: "none",
                        backgroundColor: "rgb(55, 65, 75)",
                        color: "white",
                        outline: "none",
                        cursor: "pointer"
                      }}
                    >
                      <span className="fas fa-times"></span>
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/DetailLinks/RoleFitmentReport/Modal.jsx